import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getError } from '../../redux/selectors';
import { Props } from './SubmitFormBanner';

export type StateProps = Pick<Props, 'error'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  error: getError(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
